var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDone = function SvgDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 0C8.07522 0 0 8.07451 0 18C0 27.9261 8.07522 36 18.0003 36C27.9257 36 36 27.9261 36 18C35.9997 8.07451 27.9254 0 18.0003 0ZM26.3017 15.2266L16.8508 24.6779C16.6451 24.8839 16.2806 24.8839 16.0746 24.6779L9.73422 18.3373C9.63121 18.234 9.5743 18.0966 9.5743 17.9489C9.57459 17.8019 9.6315 17.6635 9.73422 17.5597L10.5446 16.7496C10.6476 16.6469 10.7854 16.5905 10.9333 16.5905C11.0804 16.5905 11.2184 16.6469 11.3211 16.7496L16.264 21.6923C16.3734 21.8029 16.5514 21.8029 16.6611 21.6923L24.7148 13.6388C24.9208 13.4328 25.2859 13.4328 25.4913 13.6388L26.3017 14.4504C26.4047 14.5525 26.4628 14.6914 26.4628 14.8376C26.4628 14.9856 26.4047 15.1233 26.3017 15.2266Z",
    fill: "#81CC5E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done.8d5c35d9.svg";
export { ForwardRef as ReactComponent };